'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (version) {
  var major = version.split('.')[0];

  return parseInt(major, 10) < 15 ? _react2.default.createElement('noscript') : null;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-css-modules/dist/renderNothing.js
// module id = 1043
// module chunks = 1